const hexToRgb = (hex) => ({
    r: parseInt(hex.slice(1, 3), 16),
    g: parseInt(hex.slice(3, 5), 16),
    b: parseInt(hex.slice(5, 7), 16),
});
const toHex = (n) => Math.round(Math.min(255, Math.max(0, n))).toString(16).padStart(2, "0");
// WCAG relative luminance — decides whether dark or light text reads on the accent.
const relativeLuminance = ({ r, g, b }) => {
    const c = [r, g, b].map((v) => {
        const s = v / 255;
        return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
};
export const deriveAccentPalette = (accent) => {
    const { r, g, b } = hexToRgb(accent);
    const hover = `#${toHex(r * 0.85)}${toHex(g * 0.85)}${toHex(b * 0.85)}`;
    const subtle = `rgba(${r}, ${g}, ${b}, 0.14)`;
    const text = relativeLuminance({ r, g, b }) > 0.45 ? "#1c1c22" : "#ffffff";
    return { accent, accentHover: hover, accentSubtle: subtle, accentText: text };
};
//# sourceMappingURL=accent.js.map